import { isValidPhoneNumber, formatNumber } from 'libphonenumber-js';

import { OrganisationAuthSettings, State } from './types';

const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
const PHONE_NUMBER_PATTERN = /\+[\d\s]{9,15}$/i;
const EMAIL_OR_PHONE_NUMBER_PATTERN = new RegExp(
  `^(?:${EMAIL_PATTERN.source}|${PHONE_NUMBER_PATTERN.source})$`,
  [...new Set([EMAIL_PATTERN.flags, PHONE_NUMBER_PATTERN.flags])].join('')
);

const encodeState = (state: State): string => btoa(JSON.stringify(state));
const decodeState = (state: string | null): State => (state ? JSON.parse(atob(state)) : {});

const getClientId = (settings?: OrganisationAuthSettings): string => {
  if (!settings?.client_id) {
    throw new Error('No auth client ID found');
  }
  return settings.client_id;
};

const normaliseUsername = (username: string): string => {
  if (EMAIL_PATTERN.test(username)) return username;
  if (isValidPhoneNumber(username, 'GB'))
    return formatNumber(username, 'GB', 'INTERNATIONAL', { humanReadable: false }).replace(/ /g, '');
  throw new Error('Invalid username');
};

export {
  decodeState,
  EMAIL_OR_PHONE_NUMBER_PATTERN,
  EMAIL_PATTERN,
  encodeState,
  getClientId,
  normaliseUsername,
  PHONE_NUMBER_PATTERN,
};
